import { CHANGE_PAGE } from "../actions/types";

const INITIAL_STATE = {
  currentPage: "Home"
};

export default function(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case CHANGE_PAGE:
      return action.payload;
    default:
      return state;
  }
}
